import { ref, computed } from "vue";
import { Renraku, RenrakuList, RenrakuOptions, SearchItem } from "@/types/KaisyaRenraku";
import { RenrakuService } from "@/service/RenrakuService";

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(1); // APIで読み込みをする本数
  const isError = ref(false);

  const searchItem = ref<SearchItem>();
  const list = ref<RenrakuList[]>([]);

  // ログインユーザーに関連する会社連絡で既読以外を取得する
  const srv = new RenrakuService();

  const option = ref<RenrakuOptions>();

  // マスタに登録されている全ての就業場所を取得します（オプション値）
  srv.getAllOptions().then(opt => {
    if (Object.keys(opt).length <= 0) {
      // エラー
      isError.value = true;
    }
    loading.value--;
    // とりあえず代入はする
    option.value = opt;
  });

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  });

  return {
    isLoading,
    isError,
    list,
    searchItem,
    option,
  }
}
